import { apiClient } from '@/shared/api';
import {
  ConvertPredicateRequest,
  ConvertPredicateResponse,
  CreatePredicateRequest,
  PredicateMetrics,
  SmartPredicateSchema,
  UpdatePredicateRequest,
} from './types';

// POST /predicate - create a new predicate (auto-compiles DSL → SQL)
export const createPredicate = async (payload: CreatePredicateRequest) => {
  const { data } = await apiClient.post<SmartPredicateSchema>('/predicate', payload);
  return data;
};

// PUT /predicate/{predicate_id} - update an existing predicate (recompile DSL → SQL)
export const updatePredicate = async (params: { predicateId: number; body: UpdatePredicateRequest }) => {
  const { predicateId, body } = params;
  const { data } = await apiClient.put<SmartPredicateSchema>(`/predicate/${predicateId}`, body);
  return data;
};

// POST /predicate/convert - convert between NL ⇄ DSL and optionally DSL → SQL
export const convertPredicate = async (payload: ConvertPredicateRequest) => {
  const { data } = await apiClient.post<ConvertPredicateResponse>('/predicate/convert', payload);
  return data;
};

// GET /predicate/metrics - service metrics
export const fetchPredicateMetrics = async () => {
  const { data } = await apiClient.get<PredicateMetrics>('/predicate/metrics');
  return data;
};
